
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-checkbox',
  imports: [TranslateModule],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.css'
})
export class CheckboxComponent {
  @Input() label = '';
  @Input() options: any = [];
  @Input() control!: any;
  @Input() otherInfo: any;
  @Input() validationMessages: { [key: string]: string } = {};
  @Input() disabled: boolean = false;
  @Input() optionWrapperClass = '';
  @Input() stacked = false;
  @Input() translateOptions = false;
  @Output() onSelectionChange = new EventEmitter();

  get isStacked(): boolean {
    return this.stacked || Boolean(this.optionWrapperClass);
  }

  get isRequired(): boolean {
    const hasRequired = this.control?.hasValidator?.(Validators.required);
    const hasRequiredTrue = this.control?.hasValidator?.(Validators.requiredTrue);
    return Boolean(hasRequired || hasRequiredTrue);
  }
  // This method is used to error keys
  get errorKeys(): string[] {
    return this.control?.errors ? Object.keys(this.control.errors) : [];
  }

  // This method is used to handle checkbox change event using option and event
  onCheckboxChange(option: any, event: any) {
    const selected = this.control?.value || [];

    if (event.target.checked) {
      if (this.options.length > 1) {
        // Add to array if not already present
        if (!selected.includes(option)) {
          this.control.setValue([...selected, option]);
        }
      } else {
        // Set the single selected value
        this.control.setValue(option);
      }
    } else {
      if (this.options.length > 1) {
        // Remove from array
        this.control.setValue(selected.filter((o: any) => o !== option));
      } else {
        // Clear the value for single checkbox
        this.control.setValue(null);
      }
    }
    this.control.markAsTouched();
    this.onSelectionChange.emit(this.control.value)
  }

  // This method is used to check if checked using option
  isChecked(option: string): boolean {
    if (this.options.length > 1) {
      return this.control?.value?.includes(option);
    } else {
      return this.control?.value == option;
    }
  }
}
